export default __webpack_public_path__ + "static/media/team-3.ca581ae1.jpg";